export default "__VITE_ASSET__9xDx_iOO__"